module.exports = __webpack_public_path__ + "ba67994e4b66ea1c287f4d74c8572788.png";


//////////////////
// WEBPACK FOOTER
// ../lib/assets/shared/prize_1.png
// module id = 200
// module chunks = 0